import React from 'react'

const TablaAgregarListaSeleccionEspecialidad = ({item,passAgregarEspecialidadMedico}) => {
  const dataEspecialidad={
    codigoEspecialidad:item.MECodE,
    nombreEspecialidad:item.MENomE
  }
  const handleOnclickEspecialidad=()=>{
    passAgregarEspecialidadMedico(dataEspecialidad)
  }
  return (
    <tr className="border-b text-center" >
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        <button
            onClick={handleOnclickEspecialidad}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">
        {item.MECodE}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">
        {item.MENomE}
      </td>      
    </tr>
  )
}

export default TablaAgregarListaSeleccionEspecialidad